import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import useHasInvertedColors from '@hooks/useHasInvertedColors'
import Name from '@widgets/Author/Common/AuthorsWithoutImages/Name'
import BrandLogo from '@widgets/Author/Common/BrandLogo'
import { isLink } from '@widgets/Author/utils'

import { SingleAuthorProps } from '../types'

const NameAndRoleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
`

const Role = styled.span`
  ${({
    theme: {
      colors: { textWeak },
      typography: {
        subheads: {
          xsmall2: { bundledCSS: xsmall2SubheadsCSS },
        },
      },
      spacing: { spacing4 },
    },
  }) => css`
    ${xsmall2SubheadsCSS};
    color: ${textWeak};
    margin-top: ${spacing4};
  `}
`

const SingleAuthor: FunctionComponent<SingleAuthorProps> = ({
  name,
  link,
  role,
  type,
  contentOriginImage,
  contentOrigin,
  contentOriginImageDark,
}) => {
  const hasInvertedColors = useHasInvertedColors()

  const isClickable = isLink(link)
  const shouldShowRole = !!role
  const shouldWrap = type === 'basic'
  return (
    <NameAndRoleContainer>
      <Name
        isClickable={isClickable}
        shouldWrap={shouldWrap}
        hasInvertedColors={hasInvertedColors}
      >
        {name}
      </Name>
      {shouldShowRole && <Role>{role}</Role>}
      {!!contentOriginImage && (
        <BrandLogo
          contentOrigin={contentOrigin}
          contentOriginImageDark={contentOriginImageDark}
          {...contentOriginImage}
        />
      )}
    </NameAndRoleContainer>
  )
}

export default SingleAuthor
